module.exports = __webpack_public_path__ + "img/logo.538cfb00.png";